<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="editForm" :rules="rules" ref="editForm">

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="机构" required prop="institutionCode">
                <el-select v-model="editForm.institutionCode" disabled placeholder="请选择机构" style="width: 100%">
                  <el-option
                      v-for="item in arr_ins"
                      :key="item.institutionCode"
                      :label="item.userName"
                      :value="item.institutionCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="选择残疾人" required prop="elderlyCode">
                <el-input v-model="editForm.userName" placeholder="选择残疾人" disabled>
                  <el-button slot="append" icon="el-icon-search" disabled></el-button>
                  <el-button slot="prepend" icon="el-icon-close" disabled></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="入住套餐" required prop="checkinSetmealCode">
                <el-select v-model="editForm.checkinSetmealCode" placeholder="选择护理套餐" @change="setmealChange" style="width:100%">
                  <el-option
                      v-for="item in setmealList"
                      :key="item.checkinSetmealCode"
                      :label="item.name"
                      :value="item.checkinSetmealCode">
                    <span style="float: left">{{ item.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.univalence }}(元/月)</span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item" >
              <el-form-item label="床号" required prop="berthCode">
                <el-cascader
                    v-model="editForm.berthCode"
                    placeholder="请选择床号"
                    :options="ListBerth" :props="props" style="width:100%"></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="月套餐费用">
                <el-input v-model="editForm.feiView" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="月实际费用" required prop="feiTrue">
                <el-input v-model="editForm.feiTrue" placeholder="输入月实际费用"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <!--            <el-col :span="12" class="item">-->
            <!--              <el-form-item label="入住类型" required>-->
            <!--                <el-select v-model="editForm.type" placeholder="请选择入住类型" style="width:100%">-->
            <!--                  <el-option-->
            <!--                      v-for="(item,i) in typeValue"-->
            <!--                      :key="i"-->
            <!--                      :label="item"-->
            <!--                      :value="i">-->
            <!--                  </el-option>-->
            <!--                </el-select>-->
            <!--              </el-form-item>-->
            <!--            </el-col>-->
            <el-col :span="12" class="item">
              <el-form-item label="预计入住时间">
                <el-date-picker
                    v-model="editForm.beginTimePlan"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="预计入住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="预计退住时间">
                <el-date-picker
                    v-model="editForm.endTimePlan"
                    type="date"
                    style="width:100%;"
                    value-format="yyyy-MM-dd"
                    placeholder="预计退住时间">
                </el-date-picker>
              </el-form-item>
            </el-col>


          </el-row>


        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Edit',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      typeValue:['正式入住'],

      setmealList:[],
      ListBerth: [],

      props: {
        emitPath:false,
        value: 'value',
        label: 'label',
        children: 'children'
      },

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        institutionCode:'',
        elderlyCode:'',
        elderlyName:'',

        checkinSetmealCode:'',

        berthCode:'',
        type:0,

        beginTimePlan:'',
        endTimePlan:'',

        checkinCode:'',

        feiTrue:0,
        feiView:0,

      },

      rules:{

        checkinSetmealCode:[
          { required: true, message: '请选择入住套餐', trigger: 'blur' },
        ],
        berthCode:[
          { required: true, message: '请选择床号', trigger: 'blur' },
        ],
        feiTrue:[
          { required: true, message: '请输入月费用', trigger: 'blur' },
        ],

      },


    }
  },

  methods: {
    init(row){
      this.$refs.editForm.resetFields();

      this.editForm.institutionCode = row.institutionCode;
      this.editForm.checkinSetmealCode=row.checkinSetmealCode;
      this.editForm.elderlyCode=row.elderlyCode;
      this.editForm.userName = row.elderlyName;


      this.editForm.type=row.type;
      this.editForm.checkinCode=row.checkinCode;
      this.editForm.berthCode=row.berthCode;

      this.editForm.beginTimePlan = row.beginTimePlan;
      this.editForm.endTimePlan = row.endTimePlan;

      this.editForm.feiTrue = row.univalenceTrue;
      this.editForm.feiView = row.priceMonth;

      this.ListBerth = [];
      this.setmealList = [];
      this.getSetMeal();
      this.getBerth();

    },
    closeSelf() {
      this.$emit("closeEdit");
    },



    getSetMeal:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CheckinSetmeal/InsList",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          institutionCode:this.editForm.institutionCode,
        }
      }).then(
          (response) => {
            if (response.data.error == 0) {
              this.setmealList=response.data.data
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },
    setmealChange(val){

      this.editForm.checkinSetmealCode = val;
      for(let i=0;i<this.setmealList.length;i++){
        if(this.setmealList[i].checkinSetmealCode == val){
          this.editForm.feiView = this.setmealList[i].univalence;
          this.editForm.feiTrue = this.setmealList[i].univalence;
        }
      }


      this.ListBerth = [];
      this.editForm.berthCode = '';
      this.getBerth();

    },


    getBerth:function (){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Berth/InsList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.editForm.institutionCode,
          checkinSetmealCode:this.editForm.checkinSetmealCode,
          berthCode:this.editForm.berthCode,
        }
      }).then((response) => {
            //console.log(response);
            if (response.data.error == 0) {

              var datas=response.data.data

              var JSONData=JSON.stringify(datas);
              JSONData=JSONData.replace(/listRoomDTO/g,'children');
              JSONData=JSONData.replace(/listBerth/g,'children');
              JSONData=JSONData.replace(/name/g,'label');
              JSONData=JSONData.replace(/number/g,'label');

              //var list=this.getListBerth(JSON.parse(JSONData),0)
              //JSONData=JSON.stringify(list);

              //JSONData=JSONData.replace(/buildingCode/g,'value');
              //JSONData=JSONData.replace(/roomCode/g,'value');
              JSONData=JSONData.replace(/berthCode/g,'value');

              //console.log(JSONData);
              this.ListBerth=JSON.parse(JSONData);

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },





    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },
    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Checkin/GovEditIns2",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )
    },


  }
}


</script>

<style lang="scss" scoped>


</style>
